import script from "./Reports.vue?vue&type=script&setup=true&lang=ts"
export * from "./Reports.vue?vue&type=script&setup=true&lang=ts"

import "./Reports.vue?vue&type=style&index=0&id=6e98b240&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e98b240"]])

export default __exports__